import { useState } from 'react';

const disclosureSections = [
  {
    id: 'general-information',
    title: 'General Information',
    summary: 'School identity, affiliation, address, and official contact details.',
    rows: [
      ['School name', 'Shree Umiya Patidar Hr. Sec. School, Tillore Khurd'],
      ['Affiliation number', 'NA'],
      ['School code', '532296'],
      ['Complete address', 'Ward 14 Village Tillore Khurd Dist Indore MP-452020'],
      ['Principal', 'Mr. Yogesh Giri  M COM , B.Ed'],
      ['School email', 'schoolumiyapatidar@gmail.com'],
      ['Contact number', '9669745573 | 9165622285'],
    ],
  },
  {
    id: 'documents-information',
    title: 'Documents & Information',
    summary: 'Policies, certificates, recognition records, and school documents.',
    rows: [
      ['Recognition certificate', <a href="/downloads/recognition-certificate.pdf" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['Copy of no objection certificate', <a href="/downloads/affiliation-registration.pdf" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['Societies/Trust/Company Registration', <a href="/downloads/societies-trust-company-registration.jpg" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['Building safety certificate', <a href="/downloads/building-sefty-certicate.pdf" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['Fire safety certificate', 'Pending'],
      ['Water, health and sanitation certificate', <a href="/downloads/water-health-sanitation-certificate.pdf" target="_blank" rel="noopener noreferrer">View & download</a>]
    ],
  },
  {
    id: 'results-academics',
    title: 'Results & Academics',
    summary: 'Academic programmes, assessment information, and annual results.',
    rows: [
      ['Academic session', '2026-27'],
      ['Annual academic calendar', <a href="/downloads/Academic-calendar.pdf" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['Fee structure', <a href="/downloads/Fee-structure.jpg" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['School Management Committee', <a href="/downloads/School-Management-Committee.pdf" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['List of Parents Teachers Association', <a href="/downloads/parents-teachers-association.pdf" target="_blank" rel="noopener noreferrer">View & download</a>],
      ['Last Three Years of the Board Examination', 'NA'],
    ],
  },
  {
    id: 'staff-teaching',
    title: 'Staff (Teaching)',
    summary: 'Teaching strength, qualifications, and student support information.',
    rows: [
      ['Principal', '1'],
      ['Total Teaching staff', '20',[
        ['PGT', '6'],
        ['TGT', '6'],
        ['PRT', '8']
      ]],
      ['Teacher Section Ratio', '01:02.3'],
      ['Details Of Special Educator', '1'],
      ['Details Of Counsellor And Wellness Teacher', '1']
    ],
  },
  {
    id: 'school-infrastructure',
    title: 'School Infrastructure',
    summary: 'Campus facilities, accessibility, transport, and student amenities.',
    rows: [
      ['School Campus area(In Square Meters)', 'IN SQUARE MTR, and open spaces'],
      ['Number of classrooms and Size(In Square Meters)', 'Total 20 classrooms of 43 Sq.Meter each'],
      ['Number and Size of laboratories included computer(In Square Meters)', '3 Labs - 50 Sq. Meter each'],
      ['Internet availability', 'Yes'],
      ['Number of Girls Toilet', '2'],
      ['Number of Boys Toilet', '2'],
      ['Video Link: School Infrastructure Inspection', 'NA'],
    ],
  },
];

function DisclosureTable({ rows }) {
  return (
    <div className="disclosure-table-wrap">
      <table className="disclosure-table">
        <thead>
          <tr><th scope="col">Particular</th><th scope="col">Information</th></tr>
        </thead>
        <tbody>
          {rows.map(([label, value, subRows]) => (
            <tr key={label}>
              <th scope="row">{label}</th>
              <td>
                {value}
                {subRows && (
                  <table className="sub-table">
                    <tbody>
                      {subRows.map(([subLabel, subValue]) => (
                        <tr key={subLabel}>
                          <th scope="row">{subLabel}</th>
                          <td>{subValue}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function MandatoryPublicDisclosure() {
  const [openSection, setOpenSection] = useState(disclosureSections[0].id);

  return (
    <main className="disclosure-page">
      <section className="disclosure-hero">
        <div className="disclosure-hero-inner">
          <p className="disclosure-eyebrow">School information centre</p>
          <h1>Mandatory Public Disclosure</h1>
          <p>Official information for Shree Umiya Patidar Hr. Sec. School, Tillore Khurd.</p>
        </div>
      </section>

      <div className="disclosure-content">
         

        <div className="disclosure-grid disclosure-accordion">
          {disclosureSections.map((section, index) => {
            const isOpen = openSection === section.id;

            return (
            <article className={`disclosure-card${isOpen ? ' is-open' : ''}`} key={section.id}>

              <button
                className="disclosure-toggle"
                type="button"
                aria-expanded={isOpen}
                aria-controls={`${section.id}-table`}
                onClick={() => setOpenSection(isOpen ? null : section.id)}
              >
                <h3>{section.title}</h3>
                <span className="disclosure-toggle-icon" aria-hidden="true">{isOpen ? '−' : '+'}</span>
              </button>
              <p>{section.summary}</p>
              {isOpen && <div id={`${section.id}-table`} className="disclosure-accordion-content"><DisclosureTable rows={section.rows} /></div>}
            </article>
            );
          })}
        </div>

        <aside className="disclosure-note">
          <strong>Need a verified document?</strong>
          <p>For certified copies or current values marked for update, please contact the school office directly.</p>
        </aside>
      </div>

    </main>
  );
}

export default MandatoryPublicDisclosure;
